import React, { Component } from 'react';
import { Card, CardBody, Label, Col, Row } from 'reactstrap';
import Form from '../../Sumary/form'
import { Link } from 'react-router-dom';


class DetailContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataContainer: []
        }
    }

    componentDidMount = () => {
        this.props.getContainerId()
        this.buildDetail()
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            dataContainer: nextProps.data
        }, () => { this.buildDetail() })
    }

    buildDetail = () => {
        let formDetail = Form.Container.map((e, key) => {
            if (e.type === 'Tittle') {
                return (
                    <Row>
                        <div className='col-md-12' key={key} >
                            <Label tag='h4' style={{ color: 'black' }}>
                                {e.label}
                            </Label>
                            <br></br>
                        </div>
                    </Row>
                )
            }
            else if (e.type === 'Header') {
                return (
                    <Row>
                        <div className='col-md-12' key={key} style={{ color: 'black', }}>
                            <b>{e.label}</b>
                        </div>
                    </Row>
                )
            }
            else if (e.type === 'Text') {
                if (e.link) {
                    return (
                        <>
                            <Row>
                                <Col xs={4}>
                                    <span style={{ fontSize: '12px' }}>
                                        <b>{e.label}</b>
                                    </span>
                                </Col>
                                <Col xs={8}>
                                    <Label style={{ fontSize: '12px', textAlign: 'right' }}>
                                        <Link to={'/shipmentsDetail/' + this.state.dataContainer.ShipmentId}>{this.state.dataContainer[e.id]}</Link>

                                    </Label>
                                </Col>
                            </Row>
                        </>
                    )
                }
                else {
                    return (
                        <>
                            <Row>
                                <Col xs={4}>
                                    <span style={{ fontSize: '12px' }}>
                                        <b>{e.label}</b>
                                    </span>
                                </Col>
                                <Col xs={8}>
                                    <Label style={{ fontSize: '12px', textAlign: 'right' }}>
                                        {this.state.dataContainer[e.id] ? this.state.dataContainer[e.id] : '---'}
                                    </Label>
                                </Col>
                            </Row>
                        </>
                    )
                }
            }
        })
        this.setState({
            formDetail
        })
    }

    render() {
        return (
            <Card className="myCard">
                <CardBody>
                    {this.state.formDetail}
                </CardBody>
            </Card>
        )
    }
}

export default DetailContainer
